const icons = {
    "sun.png": ({ size }) => (
        <svg width={size} height={size} viewBox="0 0 64 64" fill="none">
            {/* 광선 */}
            <g stroke="#F59E0B" strokeWidth="2.5" strokeLinecap="round">
                <line x1="32" y1="4" x2="32" y2="12" />
                <line x1="32" y1="52" x2="32" y2="60" />
                <line x1="4" y1="32" x2="12" y2="32" />
                <line x1="52" y1="32" x2="60" y2="32" />
                <line x1="12.2" y1="12.2" x2="17.9" y2="17.9" />
                <line x1="46.1" y1="46.1" x2="51.8" y2="51.8" />
                <line x1="51.8" y1="12.2" x2="46.1" y2="17.9" />
                <line x1="17.9" y1="46.1" x2="12.2" y2="51.8" />
            </g>
            {/* 해 */}
            <circle cx="32" cy="32" r="13" fill="#FBBF24" stroke="#F59E0B" strokeWidth="2" />
        </svg>
    ),

    "cloudy.png": ({ size }) => (
        <svg width={size} height={size} viewBox="0 0 64 64" fill="none">
            {/* 해 (뒤) */}
            <circle cx="44" cy="20" r="10" fill="#FBBF24" stroke="#F59E0B" strokeWidth="1.5" />
            <g stroke="#F59E0B" strokeWidth="1.5" strokeLinecap="round">
                <line x1="44" y1="5" x2="44" y2="9" />
                <line x1="55" y1="9" x2="52.2" y2="11.8" />
                <line x1="59" y1="20" x2="55" y2="20" />
            </g>
            {/* 구름 */}
            <path d="M18 48 C10 48, 6 42, 10 36 C6 30, 14 24, 22 28 C24 20, 38 18, 42 26 C50 24, 56 30, 52 36 C58 40, 54 48, 46 48 Z"
                fill="#E5E7EB" stroke="#9CA3AF" strokeWidth="2" />
        </svg>
    ),

    "overcast.png": ({ size }) => (
        <svg width={size} height={size} viewBox="0 0 64 64" fill="none">
            {/* 뒤 구름 */}
            <path d="M22 42 C16 42, 12 38, 15 33 C12 28, 18 24, 24 27 C26 20, 38 19, 41 25 C47 24, 52 28, 49 33 C54 36, 50 42, 44 42 Z"
                fill="#D1D5DB" stroke="#9CA3AF" strokeWidth="1.5" />
            {/* 앞 구름 */}
            <path d="M14 52 C8 52, 4 47, 8 42 C4 37, 11 32, 18 35 C20 28, 33 26, 37 33 C44 31, 50 36, 46 42 C52 45, 48 52, 42 52 Z"
                fill="#9CA3AF" stroke="#6B7280" strokeWidth="2" />
        </svg>
    ),

    "rainy.png": ({ size }) => (
        <svg width={size} height={size} viewBox="0 0 64 64" fill="none">
            {/* 구름 */}
            <path d="M16 36 C10 36, 6 31, 10 26 C6 21, 13 16, 20 19 C22 12, 36 10, 40 18 C47 16, 53 21, 49 27 C55 30, 51 36, 44 36 Z"
                fill="#94A3B8" stroke="#64748B" strokeWidth="2" />
            {/* 빗방울 */}
            <g stroke="#3B82F6" strokeWidth="2.5" strokeLinecap="round">
                <line x1="20" y1="40" x2="17" y2="50" />
                <line x1="30" y1="40" x2="27" y2="52" />
                <line x1="40" y1="40" x2="37" y2="50" />
            </g>
        </svg>
    ),

    "shower.png": ({ size }) => (
        <svg width={size} height={size} viewBox="0 0 64 64" fill="none">
            {/* 구름 */}
            <path d="M16 34 C10 34, 6 29, 10 24 C6 19, 13 14, 20 17 C22 10, 36 8, 40 16 C47 14, 53 19, 49 25 C55 28, 51 34, 44 34 Z"
                fill="#94A3B8" stroke="#64748B" strokeWidth="2" />
            {/* 빗방울 (많이) */}
            <g stroke="#2563EB" strokeWidth="2.5" strokeLinecap="round">
                <line x1="16" y1="38" x2="13" y2="47" />
                <line x1="24" y1="39" x2="21" y2="50" />
                <line x1="32" y1="38" x2="29" y2="49" />
                <line x1="40" y1="39" x2="37" y2="48" />
                <line x1="20" y1="50" x2="18" y2="56" />
                <line x1="36" y1="50" x2="34" y2="56" />
            </g>
        </svg>
    ),

    "snowy.png": ({ size }) => (
        <svg width={size} height={size} viewBox="0 0 64 64" fill="none">
            {/* 구름 */}
            <path d="M16 34 C10 34, 6 29, 10 24 C6 19, 13 14, 20 17 C22 10, 36 8, 40 16 C47 14, 53 19, 49 25 C55 28, 51 34, 44 34 Z"
                fill="#CBD5E1" stroke="#94A3B8" strokeWidth="2" />
            {/* 눈 */}
            <g fill="#60A5FA">
                <circle cx="20" cy="42" r="3" />
                <circle cx="32" cy="46" r="3" />
                <circle cx="40" cy="41" r="3" />
                <circle cx="26" cy="54" r="2.5" />
                <circle cx="38" cy="53" r="2.5" />
            </g>
        </svg>
    ),

    "rainsnow.png": ({ size }) => (
        <svg width={size} height={size} viewBox="0 0 64 64" fill="none">
            {/* 구름 */}
            <path d="M16 34 C10 34, 6 29, 10 24 C6 19, 13 14, 20 17 C22 10, 36 8, 40 16 C47 14, 53 19, 49 25 C55 28, 51 34, 44 34 Z"
                fill="#94A3B8" stroke="#64748B" strokeWidth="2" />
            {/* 비 (왼쪽) */}
            <g stroke="#3B82F6" strokeWidth="2.5" strokeLinecap="round">
                <line x1="18" y1="39" x2="15" y2="49" />
                <line x1="28" y1="40" x2="25" y2="51" />
            </g>
            {/* 눈 (오른쪽) */}
            <g fill="#60A5FA">
                <circle cx="38" cy="42" r="3" />
                <circle cx="44" cy="51" r="2.5" />
            </g>
        </svg>
    ),

    "none.png": ({ size }) => (
        <svg width={size} height={size} viewBox="0 0 64 64" fill="none">
            <circle cx="32" cy="32" r="16" stroke="#D1D5DB" strokeWidth="2" strokeDasharray="4 3" />
            <line x1="22" y1="22" x2="42" y2="42" stroke="#D1D5DB" strokeWidth="2" />
        </svg>
    ),
};

const WeatherIcon = ({ name, size = 48 }) => {
    const Icon = icons[name];
    if (!Icon) return null;
    return <Icon size={size} />;
};

export default WeatherIcon;
